module.exports = __webpack_public_path__ + "img/bankokbank.638173b9.png";